<template>
	<div class="groupWrapper">
		<div class="chartWrapper">
			<canvas ref="myChart" width="13" height="8"></canvas>
			<div v-if="!$tracker.isHard()" class="labelBox" :class="{ labelBoxRight: selectedIndex < 48 }" :style="labelPosition">
				<div v-if="$tracker.isHard()">
					<small class="opacity-75">{{ selectedValue }}</small>
				</div>
				<div v-else>
					<small class="opacity-75">{{ selectedValue }}:</small>
					<br>
					<span>{{ labelValue }} days</span>
				</div>
			</div>
			<div class="labelDot" :style="labelPosition"></div>
		</div>
	</div>
</template>



<script>
// import {Chart, LineController, LineElement, Tooltip, BarController, BarElement, CategoryScale, PointElement, LinearScale, Title, ScatterController} from 'chart.js'
import { Chart } from 'chart.js'
import rawDaysWithSnow from '../data/number_of_days_with_snow.js';

export default {
	props: [ "selectedIndex", "selectedValue" ],
	components: {},
	data() {
		return {
			chart: null,
			labelPosition: {},
			labelValue: "0",
		};
	},
	mounted() {
		// Number of days with snow

		// 0: year
		// 1: number of days with snow cover
		// 2: running mean
		// 3: round

		let years = rawDaysWithSnow.map(row => row[0]);
		let daysSnow = rawDaysWithSnow.map(row => row[1]);
		let runningMean = rawDaysWithSnow.map(row => row[2]);
		let rounded = rawDaysWithSnow.map(row => row[3]);

		let ctx = this.$refs['myChart'].getContext('2d');
		this.chart = new Chart(ctx, {
			type: 'line',
			responsive: true,
			aspectRatio: 1,
			data: {
				labels: years,
				datasets: [
					{
						label: this.$t('graph_snow_label_smooth'),
						data: rounded,
						fill: false,
						backgroundColor: 'rgba(255, 99, 132, 0.1)',
						borderColor: 'rgba(255, 99, 132, 1)',
						borderWidth: 2,
						pointRadius: 0,
					},
					{
						label: this.$t('graph_snow_label_raw'),
						data: daysSnow,
						fill: false,
						borderColor: 'rgba(56, 163, 236, 1)',
						borderWidth: 0.4,
						pointRadius: 1,
					},
				]
			},
			options: {
				elements: {
					line: {
						tension: 0
					}
				},
				scales: {
					xAxes: [{
						ticks: {
							userCallback: function(item, index) {
								if (item % 10 == 0) {
									return Math.floor(item);
								}
							},
							autoSkip: false
						}
					}],
					yAxes: [{
						ticks: {
							// beginAtZero: true
						}
					}]
				},
				legend: {
					reverse: true
				},
				hover: {
					mode: null
				},
				tooltips: {
					mode: null
				}
			}
		});

		setTimeout(this.updateLabel, 100);
	},
	watch: {
		selectedValue(newValue) {
			this.updateLabel();
		}
	},
	methods: {
		updateLabel() {
			let dataIndex = rawDaysWithSnow.findIndex(row => row[0] == this.selectedValue);
			if (dataIndex >= 0) {
				let dataValue = rawDaysWithSnow[dataIndex][3];
				this.labelValue = dataValue.toFixed();

				let dataset = this.chart.data.datasets[0];
				let model = dataset._meta[Object.keys(dataset._meta)[0]].data[dataIndex]._model;
				this.labelPosition = {
					left: model.x.toFixed() + 'px',
					top: model.y.toFixed() + 'px',
				};
			}
		}
	}
};
</script>



<style scoped src="./graph.css"></style>
